import axios from 'axios';
import { API } from '../App';

export async function checkRentEligibility(items, token) {
  const payload = {
    items: (items || [])
      .filter((item) => item?.book_id || item?.book?.id)
      .map((item) => ({
        book_id: item.book_id || item.book?.id,
        quantity: Number(item.quantity) || 1,
      })),
  };
  const res = await axios.post(`${API}/user/rent-eligibility`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}
